import { ref } from "vue";
import { 
  getBrowserTimezone, 
  calculateDateRangeFromDays, 
  buildDateFiltersFromRange,
  executeExport
} from "@/src/utils/exportUtils.js";
import AnalyticService from "@/src/api/AnalyticService.js";

export function useCampaignExport() {
  const showExportModal = ref(false);

  const exportSingleCampaign = async ({ 
    email, 
    campaignId, 
    selectedDateRange, 
    campaignChannel 
  }) => {
    const days = parseInt(selectedDateRange);
    const filters = calculateDateRangeFromDays(days);

    const payload = {
      filters,
      export_name: `Campaign ${campaignId} Analytics (${selectedDateRange})`,
      browser_timezone: getBrowserTimezone(),
      export_email: email,
      campaign_id: parseInt(campaignId),
      is_bulk: false,
    };

    if (campaignChannel) {
      payload.channel_type = campaignChannel.toUpperCase();
    }

    return executeExport(
      () => AnalyticService.V2.exportMarketingCampaignsAnalytics(payload),
      () => { showExportModal.value = false; }
    );
  };

  const exportBulkCampaigns = async ({ 
    email, 
    dateRange, 
    selectedChannelType 
  }) => {
    const filters = buildDateFiltersFromRange(dateRange);

    const payload = {
      filters,
      export_name: "Marketing Campaigns Analytics",
      browser_timezone: getBrowserTimezone(),
      export_email: email,
      is_bulk: true,
    };

    if (selectedChannelType && selectedChannelType !== "all") {
      payload.channel_type = selectedChannelType.toUpperCase();
    }

    return executeExport(
      () => AnalyticService.V2.exportMarketingCampaignsAnalytics(payload),
      () => { showExportModal.value = false; }
    );
  };

  const openExportModal = () => {
    showExportModal.value = true;
  };

  const closeExportModal = () => {
    showExportModal.value = false;
  };

  return {
    showExportModal,
    openExportModal,
    closeExportModal,
    exportSingleCampaign,
    exportBulkCampaigns,
  };
}
